module.exports = __webpack_public_path__ + "media/images/sports_icons/015-water-polo-d54efc1af0e4fd63224f2e9bc4ae295e.png";